import React, {PureComponent as Component} from 'react';

import FormManager from "../../../../ui/template/Form/FormManager";
import {MCbrowser} from "../../../Context/browserContext";
import PropTypes from "prop-types";
import Submit from "../../../../ui/template/Form/Submit";
import followerAllowApi from "./Api/followerAllowApi";

class    FollowerAllow  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.handlePostUp = this.postUp.bind(this);
        this.state = {render:true};
        this.values = {   };

        this.form1=React.createRef();
        this.props=props;
    };

    async postUp() {
        let l=await followerAllowApi(this.props.id );
        if(l===true){
            let page = this.context.page;
            page.dispatcher.run("route","follower","edited");
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }


    render() {

        return (
            <React.Fragment>
                <FormManager ref={this.form1} submit={this.handlePostUp} className="d-block w-100">
                    <Submit  className="btn btn-primary btn-sm btn-block">
                        پذیرش
                    </Submit>
                </FormManager>
            </React.Fragment>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

FollowerAllow.propTypes = {
    id:PropTypes.string,
};

FollowerAllow.contextType = MCbrowser;

export default FollowerAllow;
